// Locale strings of report 2.1 (general-journal-summary), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "سجل اليومية العامة المجمع",
  title: "سجل اليومية العامة المجمع",
  currencyFilter: "العملة",
  allCurrencies: "الكل (جميع العملات)",
  level: "مستوى العرض",
  levelSummarized: "مجمّع (سطر لكل حساب)",
  levelDetailed: "مفصّل (حسب اليوم)",
  rollUp: "تجميع حسابات الأطراف في الحساب الرئيسي",
  section: "القسم: {title}",
  sectionHint: "يجب أن يتوازن هذا القسم وحده",
  entriesCount: "عدد القيود",
  accountsCount: "عدد الحسابات",
  net: "صافي الرصيد المتحرك",
  date: "التاريخ",
  side: "الجانب",
  sideDebit: "مدين",
  sideCredit: "دائن",
  difference: "الفرق",
  sectionTotal: "الإجمالي ({currency})",
  grandTitle: "الإجمالي العام بالعملة الأساسية",
  grandTotal: "الإجمالي بالمعادل ({currency})",
  grandAfterFx: "الإجمالي بعد فروق التحويل ({currency})",
  fxLine: "فروق تحويل العملات",
  totalDebit: "إجمالي الحركات المدينة",
  totalCredit: "إجمالي الحركات الدائنة",
  rolledUp: "مجمّع",
  rolledUpHint: "يشمل حركات {count} حساب فرعي",
  showLines: "عرض الحركات",
  hideLines: "إخفاء الحركات",
  showDays: "عرض الأيام",
  hideDays: "إخفاء الأيام",
  reference: "رقم القيد",
  leafCode: "رمز الحساب الفرعي",
  leafName: "اسم الحساب الفرعي",
  description: "البيان",
  linesCount: "عدد الأسطر",
  pageOf: "صفحة {page} من {last}",
  previous: "السابق",
  next: "التالي",
  reversal: "قيد عكسي",
  reversed: "معكوس",
  notes: "ملاحظات",
  failedLoadEntries: "تعذر تحميل حركات الحساب",
  periodRequired: "يرجى تحديد الفترة (من - إلى)",
  grandSheet: "الإجمالي العام",
};
